import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gas-icon-common',
  templateUrl: './gas-icon-common.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasIconCommonComponent { }
